import React from "react";
import { SvgIcon } from '@mui/material';
import { Row, Container, Col } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import NotApproved from '../icons/notApproved.svg?react';
import IconHolder from "../../../Helpers/IconHolder";
import PhoneCallIcon from '../../../../icons/phoneCall.svg?react';
import CustomerSupportPhone from "../../../Account/CustomerSupportPhone";
import SvgComponent from "../../../Helpers/Svg/SvgIcon";
import PermBannerImg from '../../../../assets/tools/perm_banner.jpg'
import './Ineligible.scss';

export default function Ineligible({ ineligibleProducts }) {

  const navigate = useNavigate();

  const handleRedirect = (ctaType, redirectPath) => {
    if (ctaType === "redirect" && redirectPath) {
      navigate(redirectPath);
    }
  };

  const ineligibleInfo = [
    {
      text: "We’re sorry, Americo was unable to approve your application request."
    },
    {
      text: "Don’t worry, we can help you find the right insurance coverage at the right price."
    },
    {
      text: "For an even more personalized experience, contact our team of insurance specialists."
    }
  ];

  return (
    <Container className="ineligible-div">
      <Row className="justify-content-center mb-3">
        <IconHolder icon={NotApproved} viewBox="0 0 25 25" />
      </Row>
      <Row className="justify-content-center">
        <h4 className="header-title mb-3">Thank you for your interest.</h4>
      </Row>
      {ineligibleInfo.map((data, i) =>
        <Row className="justify-content-center" key={i}>
          <Col lg={4} md={6} sm={8} xs={9} className="sub-text-div">
            <h4 className="sub-text sub-header">{data.text}</h4>
          </Col>
        </Row>
      )}
      <Row className='mt-2 d-flex justify-content-center align-items-center'>
        <SvgIcon component={PhoneCallIcon} color="primary" className='me-1 px-0' fontSize="small" />
        <b className="px-0"><a href={`tel:${CustomerSupportPhone()}`} className={`primaryLink ms-1 sub-header`}>{CustomerSupportPhone()}</a></b>
      </Row>
      <div className="header-card mt-4">
        {ineligibleProducts && ineligibleProducts.map((data, i) => {
          const bgUrl = data.backgroundImage ? data.backgroundImage : PermBannerImg;
          return (
            <Row className={`${i === 0 ? 'mt-2' : 'promoted-products-div'} justify-content-center`} key={i}>
              <Col lg={6} md={8} sm={10} className="promoted-products-sub-div w-100">
                <button
                  style={data.hasBackgroundImage ? { '--bg-image': `url(${bgUrl})` } : {}}
                  className={`promoted-product w-100 ${data.hasBackgroundImage ? "promoted-product-bg has-bg-image" : "background-color-16"}`}
                  onClick={() => handleRedirect(data.ctaType, data.redirectUri)}>
                  <div className={`content-group`}>
                    <div className={`icon-container`}>
                      <SvgComponent iconName={data.icon} className={data.hasBackgroundImage ? 'white-text' : "primary-color"} />
                    </div>
                    <h3>{data.title}</h3>
                    <p>{data.subTitle}</p>
                  </div>
                  <span className="primary-color">{data.buttonText}</span>
                </button>
              </Col>
            </Row>
          );
        })}
      </div>
    </Container>
  );
}
